import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import Caretaker from '@/models/Caretaker'

@Model()
export default class SorewardsLoadTransaction extends ApplicationRecord {
  static jsonapiType = 'sorewards_load_transactions'

  @Attr({ persist: false }) id!: string
  @Attr({ persist: false }) idDistribution!: string
  @Attr({ persist: false }) caretakerName!: string
  @Attr({ persist: false }) programFamily!: string
  @Attr({ persist: false }) dotationOrder!: string
  @Attr({ persist: false }) dotationType!: string
  @Attr({ persist: false }) dotationDate!: string
  @Attr({ persist: false }) loadDate!: string
  @Attr({ persist: false }) loadRef!: string
  @Attr({ persist: false }) expiry!: string
  @Attr({ persist: false }) amount!: number
  @Attr({ persist: false }) beneficiary!: string
  @Attr({ persist: false }) cardId!: string
  @Attr({ persist: false }) remaining!: number
  @Attr({ persist: false }) coverage!: number
  @Attr({ persist: false }) loadCost!: number | null
  @Attr({ persist: false }) negotiated!: boolean

  @BelongsTo() caretaker!: Caretaker
}
